export default __webpack_public_path__ + "static/enhancing-healthcare-ece4de180d9a1931d56b21054f8d61cb.png";